export enum DayField {
    DATE = "date",
    DAY = "day"
}
